"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_1 = require("./analytics");
window.FFAnalyticsGlobal = analytics_1.FFAnalytics;
window.FFAnalyticsGlobal.sendInit();
window.FFAnalyticsGlobal.sendPage();
exports.default = analytics_1.FFAnalytics;
